import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';

import { Currency, Lesson, Pupil, SchoolSubject, StudentClass } from '@df/interfaces';
import { TeacherService } from '@app/teacher/services/teacher.service';

@Component({
    selector: 'app-common-wrapper',
    templateUrl: './common-wrapper.component.html',
    styleUrls: ['./common-wrapper.component.scss']
})
export class CommonWrapperComponent implements OnInit, OnDestroy {
    @Input() public pupil: Pupil = null;
    @Input() public individual_data: any = null;
    @Input() extraExercise = null;

    lesson: Lesson;
    subject: SchoolSubject;
    student_class: StudentClass;
    avg_resolve_speed: number;
    avg_amount_speed: number;
    activeUrl: string = null;
    currency: Currency;

    private destroy$: Subject<boolean> = new Subject<boolean>();

    constructor(private route: ActivatedRoute, private teacherService: TeacherService) {}

    public ngOnInit(): void {
        this.route.parent.params.subscribe(params => {
            const lesson_id = params['lesson_id'];
            if (!!lesson_id) {
                this.teacherService.getInitialAnalytics(lesson_id).subscribe(response => {
                    if (response.data) {
                        this.subject = response.data.subject;
                        this.lesson = response.data.lesson;
                        this.student_class = response.data.student_class;
                        this.avg_amount_speed = response.data.avg_amount_speed.toFixed(2);
                        this.avg_resolve_speed = response.data.avg_resolve_speed.toFixed(2);
                        this.currency = response.data.currency;
                    }
                });
            }
        });
        this.route.url.pipe(takeUntil(this.destroy$)).subscribe(params => {
            this.activeUrl = params[0].path;
        });
    }

    public ngOnDestroy(): void {
        this.destroy$.next(true);
    }
}
